<template>
  <v-dialog
    v-model="showModal"
    max-width="600"
    persistent
  >
    <v-card
      outlined
      color="#ECEFF1"
    >
      <br>
      <h2 class="title-style">
        <v-icon class="icon-style">
          mdi-account-plus-outline
        </v-icon>Create Role
      </h2>
      <v-form>
        <v-container>
          <v-card-text class="text-body-1 text-center">
            <v-row
              class="fill-height"
              align-content="center"
              justify="center"
            >
              <v-col
                cols="12"
                md="8"
              >
                <v-text-field
                  v-model="newRoleName"
                  label="Name*"
                  dense
                  outlined
                  hint="Name for your reference-'userAdmin'."
                  persistent-hint
                  @keydown.space.prevent
                />
              </v-col>
            </v-row>
            <br>
            <v-textarea
              v-model="roleDescription"
              filled
              label="Role Descripion"
            />
          </v-card-text>
          <v-card-actions>
            <v-btn
              class="mt-2"
              color="red darken-3"
              @click="showModal = false"
            >
              cancel
            </v-btn>
            <v-spacer />
            <v-btn
              class="mt-2"
              color="#FF3700"
              :disabled="!isNameEntered"
              @click="createRole()"
            >
              create
            </v-btn>
          </v-card-actions>
        </v-container>
      </v-form>
    </v-card>
  </v-dialog>
</template>
<script>
  import Constants from 'src/constants';
  export default {
    data () {
      return {
        showModal: true,
        newRoleName: '',
        roleDescription: null,
      };
    },
    computed: {
      isNameEntered () {
        return this.newRoleName !== '';
      },
    },
    watch: {
      showModal: function (newval, oldval) {
        if (newval === false) {
          this.$emit('closed');
        }
      },
    },
    methods: {
      createRole () {
        this.$store.dispatch('accountcontrol/createNewRole', {
          name: this.newRoleName,
          description: this.roleDescription,
        }).then(response => {
          this.$store.dispatch('alert/onAlert', {
            message: 'Role created successfully.',
            type: Constants.ALERT_TYPE_SUCCESS,
          });
          this.$emit('role-created');
          this.showModal = false;
        });
      },
    },
  };
</script>
<style scoped>
.title-style {
  color: #37474F;
  margin-left: 30px;
}
.icon-style {
  color: #37474F;
  font-size: 45px;
}
</style>
